import { enforceDateStringToISO } from '@helpers/date';
import { PaymentsGetBankCardsResponseData, PaymentsGetBankCardsResponseDto } from '@services/dto/payments';
export const paymentsGetBankCardsResponseFromDto = (dto: PaymentsGetBankCardsResponseDto): PaymentsGetBankCardsResponseData => {
  return dto.data.map(bankCard => ({
    ...bankCard,
    creationTime: enforceDateStringToISO(bankCard.creationTime)
  }));
};